import { getEnv } from './index'

export function oauthLogin() {
  const env = getEnv()
  let url = ''
  if (env === 'local') {
    url = 'http://ssolocal.gooeto.com'
  } else if (env === 'development') {
    url = 'https://ssodev.gooeto.com'
  } else if (env === 'test') {
    url = 'https://ssotest.gooeto.com'
  } else if (env === 'pre') {
    url = 'https://pre-sso.gooeto.com'
  } else {
    url = 'https://sso.gooeto.com'
  }
  window.location.href = `${url}/oauth/authorize?client_id=hospital-manage&redirect_uri=${location.origin}/api/sso/authorization&response_type=code&&scope=all&state=${location.origin}`
}

export function oauthLogout() {
  window.location.href = `${location.origin}/api/sso/logout`
}



// WEBPACK FOOTER //
// ./src/utils/oauth.js